/**
 * 宽度变化动画
 */
import fvAnimation from "./fvAnimation"
export default class fvWidth extends fvAnimation {
    constructor(shape) {
        super(shape, "fvWidth");
        //获取宽
        this.org = this.orgWidth;
        this.orgWidth = shape.width;
        this.orgX = shape.x;
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.MaxPerc = AsyncFunction("return " + this.MaxPerc);
        this.MinPerc = AsyncFunction("return " + this.MinPerc);
    }

    async run(domObject, value) {
        if (value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        var MaxPercValue = await this.executionScript(this.MaxPerc);
        var MinPercValue = await this.executionScript(this.MinPerc);
        if (this.MaxValue == this.MinValue) return;
        if (size == -9999) return;
        var curPerc = (MaxPercValue - MinPercValue) * (size - this.MinValue) / (this.MaxValue - this.MinValue);
        // this.shape.width = this.orgWidth * curPerc / 100;
        let addWidth = this.orgWidth * curPerc / 100;
        let difference = this.shape.width - addWidth;
        switch (parseInt(this.org)) {
            case 0:
                domObject.style.width = this.orgWidth * curPerc / 100 + "px";
                break;
            case 50:
                domObject.setAttribute('x', this.shape.cx - this.shape.parent.x + (this.shape.width / 2) - (addWidth / 2));
                domObject.style.width = addWidth + "px";
                break;
            case 100:
                domObject.setAttribute('x', this.shape.cx - this.shape.parent.x + difference );
                domObject.style.width = addWidth + "px";
                break;
            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvWidth.js